<script setup lang="ts">
import type { Media } from '~/composables/useMedia'
const props = defineProps<Media>()
</script>

<template>
  <!-- Note: this component currently needs to be ClientOnly to avoid rich text hydration errors -->
  <ClientOnly>
    <MediaImage
      class="media--inline media--rich-text"
      :media="props"
      :max-width="720"
      :use-aspect="true"
      :show-captions="true"
      loading="lazy"
    />
  </ClientOnly>
</template>
